import { Injectable } from '@angular/core';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Response } from '../../../_shared/models';
import { AssetCompliance, DeleteVehicleDocumentRequest, UpdateVehicleDocumentRequest, UploadVehicleDocumentRequest, VehicleDocument, VehicleDocumentType } from '../models/vehicle-documents.model';

@Injectable({
  providedIn: 'root'
})
export class VehicleDocumentsService {

  constructor(private httpClient: HttpClient) { }

  async getDocumentTypes( cancellation: Subject<void>, excludeOther: boolean = false): Promise<Response<VehicleDocumentType[]>> {
    const params = { excludeOther };

    return firstValueFrom(
      this.httpClient.get<Response<VehicleDocumentType[]>>(
        `${environment.apiEndpoint}/VehicleDocuments/document-types`,
        { params }
      ).pipe(
        takeUntil(cancellation)
      )
    );
  }

  async getDocumentTypesByAssetId(assetId: number, cancellation: Subject<void>, excludeOther: boolean = false): Promise<Response<VehicleDocumentType[]>> {
    return firstValueFrom(
      this.httpClient.get<Response<VehicleDocumentType[]>>(`${environment.apiEndpoint}/VehicleDocuments/document-types/${assetId}`, { params: { excludeOther }, })
        .pipe(takeUntil(cancellation))
    );
  }

  async getAssetCompliances(assetId: number, cancellation: Subject<void>): Promise<Response<AssetCompliance[]>> {
    return firstValueFrom(
      this.httpClient.get<Response<AssetCompliance[]>>(`${environment.apiEndpoint}/compliance-library/assets/${assetId}/compliances`)
        .pipe(takeUntil(cancellation))
    );
  }

  async getDocumentsByAssetId(assetId: number, cancellation: Subject<void>): Promise<Response<VehicleDocument[]>> {
    return firstValueFrom(
      this.httpClient.get<Response<VehicleDocument[]>>(`${environment.apiEndpoint}/VehicleDocuments/${assetId}`)
        .pipe(takeUntil(cancellation))
    );
  }

  async getDocumentCompliances(documentId: number, cancellation: Subject<void>): Promise<Response<number[]>> {
    return firstValueFrom(
      this.httpClient.get<Response<number[]>>(`${environment.apiEndpoint}/VehicleDocuments/${documentId}/compliances`)
        .pipe(takeUntil(cancellation))
    );
  }

  async uploadTempDocument(tempDocFormData: FormData): Promise<Response<void>> {
    return firstValueFrom(
      this.httpClient.post<Response<void>>(`${environment.apiEndpoint}/VehicleDocuments/upload-temp-document`, tempDocFormData)
    );
  }

  async uploadDocument(request: UploadVehicleDocumentRequest): Promise<Response<void>> {
    return firstValueFrom(
      this.httpClient.post<Response<void>>(`${environment.apiEndpoint}/VehicleDocuments/upload`, request)
    );
  }

  async updateDocument(request: UpdateVehicleDocumentRequest): Promise<Response<void>> {
    return firstValueFrom(
      this.httpClient.put<Response<void>>(`${environment.apiEndpoint}/VehicleDocuments/update`, request)
    );
  }

  async deleteDocument(request: DeleteVehicleDocumentRequest): Promise<Response<void>> {
    return firstValueFrom(
      this.httpClient.delete<Response<void>>(`${environment.apiEndpoint}/VehicleDocuments/delete`, { body: request })
    );
  }
}
